import { Table, TableColumn, Select, Option } from 'element-ui'
import { Pagination as LPagination } from '@/components/index'
import ResourceSvc from '@/services/resource.svc.js';
import store from '@/services/store.js';
import CourseTypeSelect from '@/components/user/courses/courses-tabs/course-type-select/course-type-select.vue'

const svc = new ResourceSvc();

export default {
    title: "",
    name: 'CoursesTableTab',
    components: {
        LPagination,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        CourseTypeSelect
    },
    computed: {
        pagedData() {
            return this.tableData.slice(this.from, this.to)
        },
        to() {
            let highBound = this.from + this.pagination.perPage
            if (this.total < highBound) {
                highBound = this.total
            }
            return highBound
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1)
        },
        total() {
            this.pagination.total = store.getters.getUserCourseTotal;
            return store.getters.getUserCourseTotal;
        },
        currentTypeId() {
            return store.getters.getUserCourseType;
        },
        typeList() {
            var list = store.getters.getCourseTypes;

            list = list.filter(function (type) {
                return type.id != 0 && type.isActive == true;
            });
            if (list.length == 0) {
                list = [{ id: 0, name: 'There is no available type', isActive: true }];
            }
            return list;
        }
    },
    watch: {
        currentTypeId: function (newId) {
            this.queriedData();
        },
        typeList: function (newVal) {
            this.queriedData(true);
        }
    },
    data() {
        return {
            isForcedLoad: false,
            dataLoad: false,
            savedSearchQuery: '',
            savedCurrentTypeId: 0,
            searchTimeout: null,
            pagination: {
                perPage: 10,
                currentPage: 1,
                total: 0,
                savedPageIndex: 0,
                savedPerPage: 0,
            },
            searchQuery: '',
            tableColumns: [],
            tableData: []
        }
    },
    methods: {
        queriedData(forced) {
            var self = this;

            var types = store.getters.getCourseTypes;
            if (!types.length)
                return this.tableData;

            if (this.searchQuery != this.savedSearchQuery && !this.isForcedLoad && !forced) {

                if (this.searchTimeout) {
                    return this.tableData;
                }
                else {
                    this.searchTimeout = setTimeout(function () { self.searchTimeout = null; self.queriedData(true, false) }, 750);
                    return this.tableData;
                }
            }

            if (this.dataLoad)
                return this.tableData;
            if (this.pagination.savedPageIndex == this.pagination.currentPage && this.pagination.perPage == this.pagination.savedPerPage &&
                this.searchQuery == this.savedSearchQuery && this.savedCurrentTypeId == this.currentTypeId && !this.isForcedLoad)
                return this.tableData;

            this.isForcedLoad = false;

            var conf = { typeId: this.currentTypeId || 0, status: this.status, take: this.pagination.perPage, skip: this.from, search: this.searchQuery };
            if (conf.skip < 0) {
                conf.skip = 0;
            }

            while (this.pagination.total <= conf.skip && conf.skip) {
                this.pagination.currentPage--;
                conf.skip -= this.pagination.perPage;
                if (conf.skip < 0) {
                    conf.skip = 0;
                }
            }
            this.dataLoad = true;

            svc.userAPI.getCourses(conf).then(response => {
                self.dataLoad = false;
                self.tableData = response.body.data;
                store.commit('setUserCourseTotal', response.body.count);
                self.pagination.savedPageIndex = self.pagination.currentPage;
                self.pagination.savedPerPage = self.pagination.perPage;
                self.savedSearchQuery = self.searchQuery;
                self.savedCurrentTypeId = self.currentTypeId;
                if (response.body.data.length)
                    self.tableData = self.addTypeStr(response.body.data);
                else
                    self.tableData = [];
                return self.tableData;
            }, response => {
                //todo add interseptor
                self.tableData = [];
                self.pagination.savedPageIndex = self.pagination.currentPage;
                self.pagination.savedPerPage = self.pagination.perPage;
                self.savedSearchQuery = self.searchQuery;
                self.savedCurrentTypeId = self.currentTypeId;
                self.dataLoad = false;
                return [];
            });
        },
        addTypeStr(arr) {
            if (arr && arr.length) {
                var types = store.getters.getCourseTypes;
                if (!types.length)
                    return arr;
                arr.forEach(function (item) {
                    var currType = types.filter(function (type) {
                        return type.id == item.typeId;
                    });
                    if (currType && currType.length) {
                        item.typeStr = currType[0].name;
                    }
                });
            }
            return arr;
        }
    },
    mounted() {
        this.queriedData(true, false);
    }
}


// WEBPACK FOOTER //
// ./src/components/user/courses/courses-tabs/courses-table-tab/courses-table-tab.js